import { Component, OnInit, input, output, computed } from '@angular/core';

@Component({
  selector: 'app-table-controls',
  templateUrl: './table-controls.component.html',
  styleUrls: ['./table-controls.component.scss'],
})
export class TableControlsComponent  implements OnInit {
  
  constructor() { }

  ngOnInit() {}

  total = input.required<number>();
  currentPage = input.required<number>();
  pageSize = input.required<number>();
  
  pageChange = output<number>();

  totalPages = computed(() => Math.ceil(this.total() / this.pageSize()));
  
  startItem = computed(() => {
    if (this.total() === 0) return 0;
    return (this.currentPage() - 1) * this.pageSize() + 1;
  });

  endItem = computed(() => {
    return Math.min(this.currentPage() * this.pageSize(), this.total());
  });

  visiblePages = computed(() => {
    const total = this.totalPages();
    const current = this.currentPage();
    const range: number[] = [];
    
    // Show 3 pages around current
    let start = Math.max(1, current - 1);
    let end = Math.min(total, current + 1);
    
    // Adjust if near start or end to maintain 3 buttons if possible
    if (current === 1) end = Math.min(3, total);
    if (current === total) start = Math.max(1, total - 2);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  });

  onPageChange(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.pageChange.emit(page);
    }
  }

}
